export default __webpack_public_path__ + "static/media/icon.0ef2fd0c.svg";